module.exports = __webpack_public_path__ + "img/job-manual.27c24348.svg";